import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Divider,
  Chip
} from '@mui/material';

export default function PatientInfo({ data, removeHandler }) {
  return (
    <Card
      sx={{
        width: 320,
        flexShrink: 0,

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',

        borderRadius: 4,
        border: '1px solid',
        borderColor: 'divider',

        bgcolor: 'background.paper',

        boxShadow: '0 4px 14px rgba(0,0,0,0.05)',

      }}
    >
      <CardContent
        sx={{
          p: 3,
          flexGrow: 1,
          '&:last-child': { pb: 0 }
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Box
            sx={{
              width: 68,
              height: 68,
              borderRadius: '50%',

              background:
                'linear-gradient(135deg, rgba(25,118,210,0.12), rgba(25,118,210,0.25))',

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              border: '2px solid',
              borderColor: 'primary.light',

              flexShrink: 0
            }}
          >
            <img
              src="https://cdn-icons-png.freepik.com/512/7031/7031048.png"
              alt="User Icon"
              style={{
                width: '75%',
                height: '75%',
                objectFit: 'contain'
              }}
            />
          </Box>

          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                textTransform: 'uppercase',
                letterSpacing: 1
              }}
            >
              Paziente
            </Typography>

            <Typography
              variant="h6"
              fontWeight={700}
              color="text.primary"
            >
              {data.name}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 2.5 }} />

        {/* DIAGNOSI */}
        <Typography
          variant="subtitle2"
          fontWeight={600}
          color="text.secondary"
          sx={{ mb: 1.5 }}
        >
          Diagnosi
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1
          }}
        >
          {data.diagnosi.map((diagnosi, i) => (
            <Chip
              key={i}
              label={diagnosi}
              size="small"
              color="primary"
              variant="outlined"
              sx={{
                borderRadius: 2,
                fontWeight: 500
              }}
            />
          ))}
        </Box>
      </CardContent>

      <CardActions
        sx={{
          px: 3,
          pb: 3,
          pt: 2
        }}
      >
        <Button
          color="error"
          variant="outlined"
          onClick={() => removeHandler(data.id)}
          sx={{
            borderRadius: 2,
            fontWeight: 700,
            textTransform: 'none',
            transition: '0.2s',

            '&:hover': {
              transform: 'scale(1.03)'
            }
          }}
        >
          Rimuovi paziente
        </Button>
      </CardActions>
    </Card>
  );
}